// src/pages/AlarmPage.js
import { globalState } from "../../framework/globalState.ts";
import { DashboardAlarmHtml } from '../../components/skins/dashboard-alarm.ts';

export default function AlarmPage() {
  const container = document.createElement("div");
  container.classList.add("parent-container");
  container.innerHTML = new DashboardAlarmHtml().alarmskin();

  let alarmTableView = null;
  let searchToggle = null;

  // -----------------------------------------------------------------
  // 1. Load AlarmTableView + pass siteId from globalState
  // -----------------------------------------------------------------
  (async () => {
    try {
      const { AlarmTableView } = await import('../../components/views/AlarmTableView.js');
      const site = globalState.currentSite;

      if (!site?._id) {
        console.warn("No site selected in globalState. Alarm table disabled.");
        container.innerHTML += "<p class='text-center text-muted'>Select a site to view alarms.</p>";
        return;
      }

      // Store for cleanup & consistency
      localStorage.setItem("currentSiteId", site._id);

      alarmTableView = new AlarmTableView(container, site._id);
    } catch (err) {
        console.error("Failed to load AlarmTableView", err);
        container.innerHTML += "<p class='text-danger'>Error loading alarms.</p>";
    }
  })();

  // -----------------------------------------------------------------
  // 2. Lazy-load UI components (Dropdown, Search)
  // -----------------------------------------------------------------
  requestAnimationFrame(async () => {
    // Dropdown
    if (container.querySelector('.dropdown')) {
      const { Dropdown } = await import('../../components/dropdown.js');
      new Dropdown();
    }

    // Search Toggle
    if (container.querySelector('.search-input')) {
      const { SearchToggle } = await import('../../components/searchtoggle.js');
      searchToggle = new SearchToggle(container, '.search-input', '#searchInput', '.search-toggle');

      const input = searchToggle.input;
      input.addEventListener('input', (e) => {
        const query = e.target.value.trim().toLowerCase();
        if (alarmTableView && alarmTableView.searchQuery !== undefined) {
          alarmTableView.searchQuery = query;
          alarmTableView.renderTable();
        }
      });
    }
  });

  // -----------------------------------------------------------------
  // 3. Cleanup (critical for SPA)
  // -----------------------------------------------------------------
  container.cleanup = () => {
    if (alarmTableView && typeof alarmTableView.cleanup === 'function') {
      alarmTableView.cleanup();
    }
    if (searchToggle && typeof searchToggle.cleanup === 'function') {
      searchToggle.cleanup();
    }
  };

  return container;
}